import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const InputField = forwardRef(
  (
    {
      type = 'text',
      value = '',
      name,
      placeholder = '',
      onFocus,
      onBlur,
      onChange,
      autoComplete = 'off',
      maxLength,
    },
    ref
  ) => {
    const handleChange = e => {
      e.persist();
      onChange(e);
    };

    const handleBlur = e => {
      onBlur && onBlur(e);
    };

    const handleFocus = e => {
      onFocus && onFocus(e);
    };

    return (
      <input
        type={type}
        value={value}
        name={name}
        placeholder={placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        autoComplete={autoComplete}
        ref={ref}
        maxLength={maxLength}
      />
    );
  }
);

InputField.propTypes = {
  autoComplete: PropTypes.oneOf(['on', 'off']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['email', 'number', 'text']),
  value: PropTypes.string,
};

export default InputField;
